(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"]) return;
  try {
    
  (function () {
    if (window.vpPopupImageOnlyInit) return;
    window.vpPopupImageOnlyInit = true;

    function lockPopupWidth(modal) {
      if (!modal || !modal.classList.contains('cc-popup-modal--layout-image-only')) return;
      if (modal.getAttribute('data-vp-popup-locked') === 'true') return;
      var rect = modal.getBoundingClientRect();
      if (!rect.width) return;
      modal.style.setProperty('--vp-popup-locked-width', rect.width + 'px');
      modal.setAttribute('data-vp-popup-locked', 'true');
    }

    function scan() {
      var modals = document.querySelectorAll('.cc-popup-modal--layout-image-only');
      var i;
      for (i = 0; i < modals.length; i += 1) {
        var modal = modals[i];
        var section = modal.closest('.cc-popup');
        if (section && section.classList.contains('cc-popup--visible')) {
          lockPopupWidth(modal);
        }
      }
    }

    function start() {
      if (!document.body) return;
      var observer = new MutationObserver(function () {
        scan();
      });
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
      scan();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', function () {
      scan();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-technology-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var instances = new WeakMap();

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function currentIndex(tabs) {
      var i;
      for (i = 0; i < tabs.length; i += 1) {
        if (tabs[i].getAttribute('aria-selected') === 'true') return i;
      }
      return 0;
    }

    function restartTimer(root) {
      var ring = root.querySelector('.vp-tech-tabs__tab.is-active .vp-tech-tabs__timer-ring');
      if (!ring) return;
      ring.style.animation = 'none';
      void ring.getBoundingClientRect();
      ring.style.animation = '';
    }

    function activate(root, index) {
      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');
      var i;

      for (i = 0; i < tabs.length; i += 1) {
        var selected = i === index;
        tabs[i].setAttribute('aria-selected', selected ? 'true' : 'false');
        tabs[i].tabIndex = selected ? 0 : -1;
        tabs[i].classList.toggle('is-active', selected);
      }

      for (i = 0; i < panels.length; i += 1) {
        var match = panels[i].getAttribute('data-vp-tech-index') === String(index);
        panels[i].hidden = !match;
        panels[i].classList.toggle('is-active', match);
      }
    }

    function init(root) {
      if (!root || instances.has(root)) return;

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
      var duration = Math.max(3, parseInt(root.getAttribute('data-autoplay-speed'), 10) || 6) * 1000;
      var remaining = duration;
      var startedAt = 0;
      var timerId = null;
      var pauseReasons = {
        hover: false,
        focus: false,
        offscreen: true,
        reduced: prefersReducedMotion()
      };
      var observer = null;
      var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      function isFullyPaused() {
        return (
          !autoplayEnabled ||
          pauseReasons.hover ||
          pauseReasons.focus ||
          pauseReasons.offscreen ||
          pauseReasons.reduced
        );
      }

      function pauseClock() {
        if (timerId !== null) {
          clearTimeout(timerId);
          timerId = null;
        }
        if (startedAt) {
          remaining -= Date.now() - startedAt;
          startedAt = 0;
        }
      }

      function resumeClock() {
        if (isFullyPaused() || timerId !== null) return;
        if (remaining <= 0) remaining = duration;
        startedAt = Date.now();
        timerId = setTimeout(onTick, remaining);
      }

      function resetClock() {
        pauseClock();
        remaining = duration;
        restartTimer(root);
        if (!isFullyPaused()) resumeClock();
      }

      function onTick() {
        timerId = null;
        startedAt = 0;
        remaining = duration;
        var next = (currentIndex(tabs) + 1) % tabs.length;
        activate(root, next);
        restartTimer(root);
        if (!isFullyPaused()) resumeClock();
      }

      function syncPaused() {
        var paused = isFullyPaused();
        root.classList.toggle('is-paused', paused);
        if (paused) pauseClock();
        else resumeClock();
      }

      function setPauseReason(key, value) {
        pauseReasons[key] = value;
        syncPaused();
      }

      function onClick(event) {
        var index = parseInt(event.currentTarget.getAttribute('data-vp-tech-index'), 10);
        activate(root, index);
        resetClock();
      }

      function onKey(event) {
        var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
        if (keys.indexOf(event.key) === -1) return;
        event.preventDefault();
        var current = tabs.indexOf(event.currentTarget);
        var next = current;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          next = (current - 1 + tabs.length) % tabs.length;
        } else {
          next = (current + 1) % tabs.length;
        }
        activate(root, next);
        tabs[next].focus();
        resetClock();
      }

      function onMouseEnter() {
        setPauseReason('hover', true);
      }

      function onMouseLeave() {
        setPauseReason('hover', false);
      }

      function onFocusIn(event) {
        if (event.target.closest('[role="tab"]')) {
          setPauseReason('focus', true);
        }
      }

      function onFocusOut(event) {
        var next = event.relatedTarget;
        if (next && root.contains(next) && next.closest('[role="tab"]')) return;
        setPauseReason('focus', false);
      }

      function onMotionChange(event) {
        setPauseReason('reduced', event.matches);
      }

      for (var i = 0; i < tabs.length; i += 1) {
        tabs[i].addEventListener('click', onClick);
        tabs[i].addEventListener('keydown', onKey);
      }

      root.addEventListener('mouseenter', onMouseEnter);
      root.addEventListener('mouseleave', onMouseLeave);
      root.addEventListener('focusin', onFocusIn);
      root.addEventListener('focusout', onFocusOut);

      if (motionQuery.addEventListener) {
        motionQuery.addEventListener('change', onMotionChange);
      } else if (motionQuery.addListener) {
        motionQuery.addListener(onMotionChange);
      }

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            setPauseReason('offscreen', !(entry && entry.isIntersecting));
          },
          { threshold: 0 }
        );
        observer.observe(root);
      } else {
        setPauseReason('offscreen', false);
      }

      syncPaused();
      root.classList.add('is-enhanced');
      instances.set(root, {
        tabs: tabs,
        onClick: onClick,
        onKey: onKey,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocusIn: onFocusIn,
        onFocusOut: onFocusOut,
        onMotionChange: onMotionChange,
        motionQuery: motionQuery,
        observer: observer,
        pauseClock: pauseClock
      });
    }

    function destroy(root) {
      var inst = instances.get(root);
      if (!inst) return;
      var i;
      if (inst.pauseClock) inst.pauseClock();
      for (i = 0; i < inst.tabs.length; i += 1) {
        inst.tabs[i].removeEventListener('click', inst.onClick);
        inst.tabs[i].removeEventListener('keydown', inst.onKey);
      }
      root.removeEventListener('mouseenter', inst.onMouseEnter);
      root.removeEventListener('mouseleave', inst.onMouseLeave);
      root.removeEventListener('focusin', inst.onFocusIn);
      root.removeEventListener('focusout', inst.onFocusOut);
      if (inst.motionQuery) {
        if (inst.motionQuery.removeEventListener) {
          inst.motionQuery.removeEventListener('change', inst.onMotionChange);
        } else if (inst.motionQuery.removeListener) {
          inst.motionQuery.removeListener(inst.onMotionChange);
        }
      }
      if (inst.observer) inst.observer.disconnect();
      instances.delete(root);
    }

    function initAll() {
      var roots = document.querySelectorAll('.vp-tech-tabs');
      for (var i = 0; i < roots.length; i += 1) {
        init(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.vp-tech-tabs');
      if (root) init(root);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('.vp-tech-tabs');
      if (root) destroy(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
